export default {"src":"/_next/static/media/HCP.25cd223a.svg","height":18,"width":18};